import { getFavouriteDeparturesAction } from "../../../Actions/LogicActions/Search/GetFavouriteDeparturesAction";
import { getTrainOfferContinueAction } from "../../../Actions/LogicActions/TrainOffer/GetTrainOfferContinueAction";
import { destinationBookNowAction } from "../../../Actions/UIActions/CMSDestination/DestinationBookNowAction";
import { ExecutionStatus } from "../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree, trainOfferEvtTree } from "../../../Orchestrator/ConstantTree";
import { TrainOfferRequest } from "../../../Orchestrator/Types/Index";
import { ICMSBookNowParams } from "../../../Orchestrator/Types/Interface/ICmsDestination";
import { FavouriteDepartureContext } from "../Context/FavouriteDepartureContext";

class FavouriteDepartureInitStep extends StepFlow {
    get stepName() { return "FavouriteDepartureInit_Step"; }

    async onEventSetup(): Promise<void> {
        // Disabled — old getFavouriteDeparturesAction makes 3 /retailer/offers calls.
        // Re-enable here if/when the widget is brought back.
        // this.registerEventSubscription(
        //     _eventBus.on({
        //         eventName: evtTree.favouriteDepartures.Get,
        //         handler: async () => {
        //             getFavouriteDeparturesAction.execute();
        //         }
        //     })
        // );

        this.registerEventSubscription(
            _eventBus.on<ICMSBookNowParams, void>({
                eventName: evtTree.DestinationDetail.BookNow.Click,
                handler: async ({ data }) => {
                    if (data) {
                        destinationBookNowAction.setParams(data!);
                        destinationBookNowAction.execute();
                    }
                },
            })
        );

        this.registerEventSubscription(
            _eventBus.on<TrainOfferRequest, void>({
                eventName: trainOfferEvtTree.Offer.ContinueBtn.Click,
                handler: async (payload) => {
                    getTrainOfferContinueAction.setParams(payload.data!);
                    await getTrainOfferContinueAction.execute();
                    if (getTrainOfferContinueAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                        const data = getTrainOfferContinueAction.result!;
                        if (data.returnText === "success" && data.checkoutRedirect == true) {
                            sessionStorage.setItem("checkoutFromWithLogin", "true")

                            const favContext = this.getCtx<FavouriteDepartureContext>("favouriteDepartureContext");
                            if (favContext) {
                                favContext.routeTo = ["CheckoutFlow"];
                                this.next();
                            }


                            // Delay the ROUTE_CHANGE event emission slightly
                            setTimeout(() => {
                                _eventBus.emit({
                                    eventName: "ROUTE_CHANGE",
                                    data: "/checkout"
                                });
                            }, 0); // setTimeout with 0ms delay
                        }
                    }
                }
            })
        )
    }

    async onExecute(): Promise<void> {
        if (window && window.location.href.includes("/search")) {
            console.log("FavouriteDeparture Init Step Execute...");
            this.eventBus.emit({
                eventName: evtTree.favouriteDepartures.Get,
            });
        }
    }
}

export const FavouriteDepartureInitStepDeclaration = new StepDefinition({
    stepName: "FavouriteDepartureInit_Step",
    stepClass: FavouriteDepartureInitStep
});